import { LogoLoader } from './LogoLoader';

import { Stack } from '@cast/design-system';

export const CenteredLogoLoader = () => (
  <Stack alignItems="center" mt={16}>
    <LogoLoader />
  </Stack>
);
